import React from 'react';
import styles from './ValidationFeedback.module.css';

const VALIDATION_TYPE = {
  ERRORS: 'errors',
  WARNINGS: 'warnings',
  SUCCESS: 'success',
};

const ValidationFeedback = ({ data, type }) => {
  const getValidationTypeClass = () => {
    switch (type) {
      case VALIDATION_TYPE.ERRORS:
        return styles.error;
      case VALIDATION_TYPE.SUCCESS:
        return styles.success;
      case VALIDATION_TYPE.WARNINGS:
        return styles.warning;
      default:
        return '';
    }
  };
  const getValidationTitle = () => {
    switch (type) {
      case VALIDATION_TYPE.ERRORS:
        return 'Errors';
      case VALIDATION_TYPE.SUCCESS:
        return 'Success';
      case VALIDATION_TYPE.WARNINGS:
        return 'Warnings';
      default:
        return '';
    }
  };
  return (
    <div
      className={`${
        styles.validationFeedbackContainer
      } ${getValidationTypeClass()}`}
    >
      <div className={styles.validationFeedbackTitleWrapper}>
        <h2>{getValidationTitle()}</h2>
      </div>
      <div className={styles.validationFeedbackContent}>
        {type === VALIDATION_TYPE.ERRORS ? (
          <p>Please fix the following errors and reupload your file:</p>
        ) : null}
        {data.map((item, index) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            className={styles.validationFeedbackItem}
          >
            {item.title ? <h3>{item.title}</h3> : null}
            <p>{item.description}</p>
            {item.details && (
              <pre className={styles.details}>{item.details}</pre>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ValidationFeedback;
